import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-sm text-gray-900"
}
const _hoisted_2 = {
  key: 1,
  class: "text-[10px] text-gray-600 mt-1"
}

import { computed } from 'vue';
import Multiselect from '@vueform/multiselect';


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiselectInput',
  props: {
    modelValue: {
        default: null,
        required: true
    },
    error: {
        type: String,
        default: null,
    },
    mode: {
        type: String,
        default: 'single' // single | multiple | tags
    },
    searchable: {
        type: Boolean,
        default: true
    },
    id: {
        type: String,
    },
    name: {
        type: String,
    },
    label: {
        type: String,
    },
    placeholder: {
        type: String,
        default: 'Placeholder'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    options: {
        type: Object,
        default: () => ({
            1: 'Option 1',
            2: 'Option 2',
            3: 'Option 3'
        })
    },
    helper: {
        type: String,
        default: null,
    },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit

const value = computed<object>({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(Multiselect), {
      id: __props.id,
      name: __props.name,
      mode: __props.mode,
      searchable: __props.searchable,
      placeholder: __props.placeholder,
      disabled: __props.disabled,
      options: __props.options,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change'))),
      onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select'))),
      onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clear'))),
      class: _normalizeClass(["frm-multiselect", [__props.error ? 'error' : '']])
    }, null, 8, ["id", "name", "mode", "searchable", "placeholder", "disabled", "options", "modelValue", "class"]),
    (__props.helper)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "form-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})